(function ($) {
    $(document).ready(function () {
        $('body').trigger('bless');

        if ($('.page-template-template-board').length > 0) {

            var Flickity = require('flickity');
            var jQueryBridget = require('jquery-bridget');
            require('flickity-imagesloaded');

            jQueryBridget('flickity', Flickity, $);

            var $boardSlider = $('.board-member-slider');
            if ($boardSlider.length) {
                var fktyboard = new Flickity('.board-member-slider', {
                    cellSelector: '.board-member-slidercell',
                    prevNextButtons: false,
                    autoPlay: false,
                    draggable: false,
                    contain: true,
                    pageDots: false,
                    lazyLoad: 3,
                    watchCSS: true,
                    freeScroll: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                });


                $('.board-member-slidercell, .board-member').on('click', '.button', function () {
                    var selector = $(this).attr('data-selector');
                    $boardSlider.flickity('selectCell', selector);
                    $('.subfooter').addClass('slider-active');
                });

                $('.board-member').on('click', function () {
                    $('html, body').animate({
                        scrollTop: $('.slider-active').offset().top - 100
                    }, 500);
                    $boardSlider.show()
                    // trigger resize method after showing
                        .flickity('resize');
                });
            }
        }

        if ($('.page-template-template-collection').length > 0) {
            var collection_wrapper = $(".collection-wrapper > .flex-item");
            for (var i = 0; i < collection_wrapper.length; i += 3) {
                collection_wrapper.slice(i, i + 3).wrapAll("<div class='collection-row'></div>");
            }
        }

    });

})(jQuery);